(function () {
  'use strict';

  var burger = document.querySelector('.v2-burger');
  var drawer = document.getElementById('v2-drawer');
  if (!burger || !drawer) return;

  var backdrop     = drawer.querySelector('.v2-drawer__backdrop');
  var drawerPanel  = drawer.querySelector('.v2-drawer__panel');
  var closeBtn     = drawer.querySelector('.v2-drawer__close');

  var sidebarBtns  = drawer.querySelectorAll('.v2-sidebar__btn');
  var sidebarLinks = drawer.querySelectorAll('.v2-sidebar__link');
  var panels       = drawer.querySelectorAll('.v2-panel');
  var l2Items      = drawer.querySelectorAll('.v2-l2');
  var l3Panels     = drawer.querySelectorAll('.v2-l3');
  var previewLinks = drawer.querySelectorAll('[data-preview-url]');
  var mobPages     = drawer.querySelectorAll('[data-mob-page]');

  var previewArea  = drawer.querySelector('[data-preview-area]');

  var DESKTOP_BP = 1024;

  function isDesktop() {
    return window.innerWidth >= DESKTOP_BP;
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    resetAll();
    burger.focus();
  }

  burger.addEventListener('click', function () {
    if (drawer.classList.contains('is-open')) closeDrawer();
    else openDrawer();
  });

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (backdrop) backdrop.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  function hideL3() {
    l3Panels.forEach(function (p) { p.hidden = true; });
    l2Items.forEach(function (it) { it.classList.remove('is-active'); });
    if (drawerPanel) drawerPanel.classList.remove('has-l3');
  }

  // ── Vorschau ──────────────────────────────────────────────────────────
  // Der Inhalt kommt per Section Rendering API erst beim Hovern.

  var PREVIEW_SECTION = 'supplementa-menu-preview';
  var PREVIEW_DELAY = 120;

  var previewCache = {};
  var previewTimer = null;
  var previewRequest = null;
  var previewUrl = null;
  var previewLabel = '';

  function previewEndpoint(url) {
    var parsed = new URL(url, window.location.origin);
    parsed.searchParams.set('section_id', PREVIEW_SECTION);
    return parsed.pathname + parsed.search;
  }

  function renderPreview(url, markup) {
    // Zwischenzeitlich weitergefahren: Antwort gehört nicht mehr zum Ziel.
    if (!previewArea || previewUrl !== url) return;

    if (!markup || !markup.trim()) {
      hidePreview();
      return;
    }

    previewArea.innerHTML = markup;

    // Die Beschriftung aus dem Menü ist redaktionell gepflegt und gewinnt
    // gegen den Kollektions- oder Produkttitel aus der Section.
    var title = previewArea.querySelector('.v2-preview__title');
    if (title && previewLabel) title.textContent = previewLabel;

    if (drawerPanel) drawerPanel.classList.add('has-preview');
  }

  function fetchPreview(url) {
    if (previewRequest) previewRequest.abort();
    previewRequest = new AbortController();

    fetch(previewEndpoint(url), { signal: previewRequest.signal })
      .then(function (res) { return res.ok ? res.text() : ''; })
      .then(function (markup) {
        previewCache[url] = markup;
        renderPreview(url, markup);
      })
      .catch(function () {
        // Abbruch beim schnellen Weiterfahren ist der Normalfall.
      });
  }

  function requestPreview(link) {
    var url = link.getAttribute('data-preview-url');
    if (!url) {
      hidePreview();
      return;
    }

    previewUrl = url;
    previewLabel = (link.querySelector('.v2-l2__title') || link).textContent.trim();

    clearTimeout(previewTimer);

    if (previewCache[url] !== undefined) {
      renderPreview(url, previewCache[url]);
      return;
    }

    previewTimer = setTimeout(function () { fetchPreview(url); }, PREVIEW_DELAY);
  }

  function hidePreview() {
    clearTimeout(previewTimer);
    previewUrl = null;
    if (previewArea) previewArea.innerHTML = '';
    if (drawerPanel) drawerPanel.classList.remove('has-preview');
  }

  function resetAll() {
    sidebarBtns.forEach(function (b) {
      b.classList.remove('is-active');
      b.setAttribute('aria-expanded', 'false');
    });
    panels.forEach(function (p) { p.hidden = true; });
    mobPages.forEach(function (s) { s.classList.remove('is-open'); });
    hideL3();
    hidePreview();
    if (drawerPanel) drawerPanel.classList.remove('has-content');
  }

  function activateCategory(catId) {
    var activePanel = null;
    sidebarBtns.forEach(function (b) {
      var active = b.getAttribute('data-cat') === catId;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-expanded', active ? 'true' : 'false');
    });
    panels.forEach(function (p) {
      var match = p.getAttribute('data-panel') === catId;
      p.hidden = !match;
      if (match) activePanel = p;
    });

    hideL3();
    hidePreview();

    if (drawerPanel) {
      drawerPanel.classList.toggle('has-content', !!activePanel);
    }
  }

  function showL3(l2Id) {
    l2Items.forEach(function (it) {
      it.classList.toggle('is-active', it.getAttribute('data-l2') === l2Id);
    });
    var found = false;
    l3Panels.forEach(function (p) {
      var match = p.getAttribute('data-l3') === l2Id;
      p.hidden = !match;
      if (match) found = true;
    });
    if (drawerPanel) drawerPanel.classList.toggle('has-l3', found);
  }

  sidebarBtns.forEach(function (btn) {
    btn.addEventListener('mouseenter', function () {
      if (!isDesktop()) return;
      activateCategory(this.getAttribute('data-cat'));
    });

    btn.addEventListener('click', function () {
      var catId = this.getAttribute('data-cat');
      if (isDesktop()) {
        activateCategory(catId);
        return;
      }
      openMobPage(catId);
    });
  });

  sidebarLinks.forEach(function (link) {
    link.addEventListener('mouseenter', function () {
      if (!isDesktop()) return;
      resetAll();
    });
  });

  l2Items.forEach(function (item) {
    var hasChildren = item.classList.contains('v2-l2--has-children');
    var link = item.querySelector('.v2-l2__link');

    item.addEventListener('mouseenter', function () {
      if (!isDesktop()) return;

      if (hasChildren) {
        showL3(this.getAttribute('data-l2'));
      } else {
        hideL3();
      }

      if (link && link.hasAttribute('data-preview-url')) requestPreview(link);
      else hidePreview();
    });

    // Mobil führt ein Eintrag mit Unterpunkten auf die nächste Seite statt
    // direkt in die Kategorie. Die Kategorie selbst bleibt dort über
    // "Alle anzeigen" erreichbar.
    if (!hasChildren || !link) return;

    link.addEventListener('click', function (e) {
      if (isDesktop()) return;
      e.preventDefault();
      openMobPage(item.getAttribute('data-l2'));
    });
  });

  previewLinks.forEach(function (link) {
    link.addEventListener('mouseenter', function () {
      if (!isDesktop()) return;
      requestPreview(this);
    });
  });

  if (drawerPanel) {
    drawerPanel.addEventListener('mouseleave', function () {
      if (!isDesktop()) return;
      hidePreview();
    });
  }

  function openMobPage(pageId) {
    var page = drawer.querySelector('[data-mob-page="' + pageId + '"]');
    if (!page) return;
    // Auf Desktop steuert das hidden-Attribut die Sichtbarkeit. Mobil muss es
    // weg, sonst bleibt die eingeschobene Seite aus dem Accessibility-Baum.
    page.hidden = false;
    page.classList.add('is-open');
  }

  drawer.querySelectorAll('[data-mob-back]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var page = btn.closest('[data-mob-page]');
      if (page) page.classList.remove('is-open');
    });
  });
})();

(function initStickyHeader() {
  'use strict';

  var header = document.querySelector('.v2-header[data-sticky-header]');
  if (!header) return;

  // Richtungswechsel unter dieser Distanz ignorieren, sonst flackert der Header
  // bei Trackpad-Jitter und iOS-Bounce.
  var DIRECTION_THRESHOLD = 6;

  var drawer = document.getElementById('v2-drawer');

  var spacer = document.createElement('div');
  spacer.className = 'v2-header__spacer';
  header.parentNode.insertBefore(spacer, header.nextSibling);

  var lastY = window.pageYOffset;
  var stuck = false;
  var revealed = false;
  var ticking = false;
  var lastOffset = null;

  function headerHeight() {
    return header.offsetHeight;
  }

  // Andere Komponenten müssen wissen, wie viel Platz der fixierte Header
  // überdeckt – etwa die sticky Produktspalte, die sonst darunter andockt.
  // --sup-header-height ist die reine Höhe, --sup-header-offset der Streifen,
  // den der Header im Moment wirklich verdeckt. Ausgefahren verdeckt er nichts,
  // deshalb ist der Offset dann null und die Spalte darf nach oben nachrücken.
  function publishMetrics() {
    var style = document.documentElement.style;
    var offset = stuck && revealed ? headerHeight() : 0;
    style.setProperty('--sup-header-height', headerHeight() + 'px');
    style.setProperty('--sup-header-offset', offset + 'px');

    // Die sticky Produktspalte rechnet ihre Position nur bei Scroll-Events neu.
    // Der Header fährt aber erst als Folge des letzten Events ein, sie bliebe
    // also dauerhaft beim vorherigen Wert stehen. Deshalb der aktive Anstoß.
    if (offset === lastOffset) return;
    lastOffset = offset;
    window.dispatchEvent(new CustomEvent('on:header-offset-change'));
  }

  // Dokumentposition des Headers im normalen Fluss. Solange er fixiert ist,
  // hält der Spacer diese Position, sonst misst der Header sich selbst.
  function flowOffset() {
    var ref = stuck ? spacer : header;
    return ref.getBoundingClientRect().top + window.pageYOffset;
  }

  function setStuck(next) {
    if (stuck === next) return;
    stuck = next;
    spacer.style.height = next ? headerHeight() + 'px' : '';
    spacer.classList.toggle('is-active', next);
    header.classList.toggle('is-stuck', next);
    if (!next) {
      revealed = false;
      header.classList.remove('is-revealed');
    }
    publishMetrics();
  }

  function setRevealed(next) {
    if (revealed === next) return;
    revealed = next;
    header.classList.toggle('is-revealed', next);
    publishMetrics();
  }

  function update() {
    ticking = false;

    var y = window.pageYOffset;
    if (y < 0) y = 0;

    var base = flowOffset();

    // Hysterese: Fixieren erst, wenn der Header komplett aus dem Viewport
    // gescrollt ist, Lösen erst wieder an seiner Ursprungsposition. Ohne diesen
    // Abstand würde der Header beim Wechsel der Positionierung sichtbar
    // springen, weil fixiert und im Fluss unterschiedlich hoch stehen.
    if (y <= base) {
      setStuck(false);
      lastY = y;
      return;
    }

    if (!stuck) {
      if (y <= base + headerHeight()) {
        lastY = y;
        return;
      }
      setStuck(true);
    }

    if (drawer && drawer.classList.contains('is-open')) {
      setRevealed(true);
      lastY = y;
      return;
    }

    var delta = y - lastY;
    if (Math.abs(delta) < DIRECTION_THRESHOLD) return;

    setRevealed(delta < 0);
    lastY = y;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    if (stuck) spacer.style.height = headerHeight() + 'px';
    publishMetrics();
    onScroll();
  }, { passive: true });

  publishMetrics();
  update();
})();

(function initV2Search() {
  var BLOG_HANDLES = { lexikon: 'lexikon', magazin: 'magazin', rezepte: 'rezepte' };

  function articleMatchesBlog(url, handle) {
    return !!url && !!handle && url.indexOf('/blogs/' + handle + '/') !== -1;
  }

  function parseArticlesFromMarkup(root) {
    var dataEl = root.querySelector('.psearch-articles-data');
    if (!dataEl) return null;

    try {
      var parsed = JSON.parse(dataEl.textContent);
      return Array.isArray(parsed) ? parsed : null;
    } catch (err) {
      return null;
    }
  }

  function buildArticleItemHtml(article) {
    var li = document.createElement('li');
    li.className = 'predictive-search__item';
    li.setAttribute('role', 'option');

    var anchor = document.createElement('a');
    anchor.className = 'psearch-result flex js-search-link focus-inset';
    anchor.href = article.url;

    if (article.image) {
      var media = document.createElement('div');
      media.className = 'psearch-result__media media relative';

      var img = document.createElement('img');
      img.className = 'psearch-result__img';
      img.loading = 'eager';
      img.src = article.image;
      img.alt = article.title || '';

      media.appendChild(img);
      anchor.appendChild(media);
    }

    var info = document.createElement('div');
    info.className = 'psearch-result__info flex-auto';

    var title = document.createElement('span');
    title.className = 'psearch-result__title';
    title.textContent = article.title || '';

    info.appendChild(title);
    anchor.appendChild(info);
    li.appendChild(anchor);

    return li.outerHTML;
  }

  function filterBlogMarkup(markup, handle) {
    if (!markup || !handle) return markup;

    var tmpl = document.createElement('template');
    tmpl.innerHTML = markup;
    var root = tmpl.content.querySelector('.predictive-search.psearch');
    if (!root) return markup;

    root.setAttribute('data-layout', 'blog');

    var articles = parseArticlesFromMarkup(root);
    var filtered = [];
    var seen = Object.create(null);

    if (articles) {
      articles.forEach(function (article) {
        if (!article || !article.url || !articleMatchesBlog(article.url, handle)) return;
        if (seen[article.url]) return;
        seen[article.url] = true;
        filtered.push(article);
      });
    }

    if (filtered.length === 0) {
      root.querySelectorAll('[data-group="articles"] .predictive-search__item:not(.js-submit)').forEach(function (item) {
        var link = item.querySelector('a[href]');
        if (!link) return;
        var href = link.getAttribute('href') || '';
        if (!articleMatchesBlog(href, handle) || seen[href]) return;
        seen[href] = true;
        filtered.push({
          url: href,
          title: (link.querySelector('.psearch-result__title') || link).textContent.trim(),
          image: (link.querySelector('img') || {}).src || null
        });
      });

      root.querySelectorAll('[data-group="pages"] .psearch-page[href]').forEach(function (link) {
        var href = link.getAttribute('href') || '';
        if (!articleMatchesBlog(href, handle) || seen[href]) return;
        seen[href] = true;
        filtered.push({ url: href, title: link.textContent.trim(), image: null });
      });
    }

    var body = root.querySelector('.psearch__body');
    if (!body) return tmpl.innerHTML;

    var viewAllBtn = root.querySelector('.js-submit .psearch-viewall');
    var viewAllHtml = viewAllBtn ? viewAllBtn.innerHTML : 'Alle anzeigen';

    body.className = 'psearch__body';
    body.innerHTML = '';

    var main = document.createElement('div');
    main.className = 'psearch__main';

    var section = document.createElement('section');
    section.className = 'psearch-group';
    section.setAttribute('data-group', 'articles');

    if (filtered.length === 0) {
      var noResults = document.createElement('div');
      noResults.className = 'predictive-search__no-results';
      noResults.textContent = 'Keine Ergebnisse gefunden';
      section.appendChild(noResults);
    } else {
      var list = document.createElement('ul');
      list.className = 'psearch-list';
      list.setAttribute('role', 'list');

      filtered.forEach(function (article) {
        list.insertAdjacentHTML('beforeend', buildArticleItemHtml(article));
      });

      var submitItem = document.createElement('li');
      submitItem.className = 'predictive-search__item js-submit';
      submitItem.setAttribute('role', 'option');
      submitItem.innerHTML = '<button class="psearch-viewall js-search-link has-ltr-icon focus-inset" type="submit">' +
        viewAllHtml + '</button>';
      list.appendChild(submitItem);
      section.appendChild(list);
    }

    main.appendChild(section);
    body.appendChild(main);

    var dataNode = root.querySelector('.psearch-articles-data');
    if (dataNode) dataNode.remove();

    return tmpl.innerHTML;
  }

  function getDefaultPreviewMarkup(scope) {
    if (scope === 'products') {
      var productsTpl = document.getElementById('psearch-default-template');
      return productsTpl ? productsTpl.innerHTML : '';
    }
    var blogTpl = document.getElementById('psearch-default-' + scope);
    return blogTpl ? blogTpl.innerHTML : '';
  }

  function applySearchScope(wrapper, ps, scope) {
    ps.dataset.psearchScope = scope;
    ps.dataset.psearchResourceTypes = scope === 'products'
      ? 'product,collection,article'
      : 'article';
    wrapper.setAttribute('data-scope', scope);
  }

  document.querySelectorAll('.v2-search').forEach(function (wrapper) {
    var select = wrapper.querySelector('.v2-scope__select');
    var input = wrapper.querySelector('.js-search-input');
    var ps = wrapper.querySelector('predictive-search');

    if (!select || !input || !ps) return;

    var psProto = Object.getPrototypeOf(ps);
    var origRenderResults = psProto.renderResults;
    var scope = select.value || 'products';

    applySearchScope(wrapper, ps, scope);

    ps.showDefaultPreview = function () {
      var markup = getDefaultPreviewMarkup(scope);
      if (!markup.trim()) return false;
      origRenderResults.call(ps, markup);
      ps.setAttribute('results', 'default');
      return true;
    };

    ps.renderResults = function (markup) {
      if (markup.indexOf('data-psearch-mode="default"') !== -1) {
        return origRenderResults.call(ps, markup);
      }
      var output = scope !== 'products' ? filterBlogMarkup(markup, BLOG_HANDLES[scope]) : markup;
      return origRenderResults.call(ps, output);
    };

    select.addEventListener('change', function () {
      scope = select.value;
      applySearchScope(wrapper, ps, scope);
      ps.cachedResults = {};

      if (input.value.trim().length > 0) {
        psProto.handleInput.call(ps);
      } else if (typeof ps.showDefaultPreview === 'function' && ps.showDefaultPreview()) {
        return;
      } else if (typeof ps.close === 'function') {
        ps.close();
      }
    });

    var form = wrapper.querySelector('form.search');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var q = input.value.trim();
        if (!q) return;

        // Ein-Wort-Queries mit `*` erweitern: `body` durchsuchbar machen
        // Mehrwortige Queries bleiben unverändert
        if (!/\s/.test(q) && !/[*"]$/.test(q)) {
          q += '*';
        }

        var params = 'q=' + encodeURIComponent(q) + '&options[prefix]=last';
        if (scope === 'products') {
          // Exclude free "Verlag" items (price 0) that pollute product results
          params += '&type=product&filter.v.price.gte=0.01';
        } else {
          var blogHandle = BLOG_HANDLES[scope] || scope;
          params += '&type=article&scope=' + encodeURIComponent(blogHandle);
        }
        window.location.href = '/search?' + params;
      });
    }
  });
})();

